import { connect } from "react-redux";
import RmAssignTicket from "./rmAssignTicket";
import { bindActionCreators } from "redux";
import {postTicketAssignment} from "services/redux/maintenance/rmTicket/action";
import {fetchPmAssignee} from "services/redux/maintenance/pmTicket/action";
import {
  fetchRmTicketDetails,
} from "services/redux/maintenance/rmTicket/action";

const mapStateToProps = (state) => ({
  pmTicketAssignee: state.pmTicketReducer.pmTicketAssignee,
  pmAssigneeList: state.pmTicketReducer.pmAssigneeList,
  rmTicketDetails: state.rmTicketReducer.rmTicketDetails,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchPmAssignee,
      postTicketAssignment,
      fetchRmTicketDetails,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(RmAssignTicket);
